import { en } from "./en";
export const t = en;
export const locale = "en-LB";
